import {
  LOADING_STATUS,
} from '../types';

const setStatus = function setStatus(status) {
  return {
    type: LOADING_STATUS,
    status,
  };
};

export default {
  setStatus,
};



// WEBPACK FOOTER //
// ./src/state/actions/loading.js